import { Injectable, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ZabbixOverviewService {

  constructor(    
    @Inject('ZabbixOverviewFactory') private zabbixOverviewFactory: any
  ) { }


  fillHashCodes = (coachData: any) => {
    return this.zabbixOverviewFactory.fillHashCodes(coachData);
  }

  fillPriorities = (hashStructure: any) => {
    return this.zabbixOverviewFactory.fillPriorities(hashStructure);
  }
  
  reloadOldStructure = (tree: any, structure: any) => {
    return this.zabbixOverviewFactory.reloadOldStructure(tree, structure);
  }

}
